import logger from '@redbubble/next/logger';
/**
 * For use in the client to ensure URLs are safe to use.
 * URL.parse is not always available in the client, so we use the
 * URL constructor with a try-catch to handle any errors.
 * When parsing urls in the server we prefer the use of URL.parse
 */
export const getSafeUrl = (url, base) => {
    try {
        const safeUrl = base ? new URL(url, base) : new URL(url);
        return safeUrl;
    }
    catch (err) {
        const malformedUrl = typeof url === 'string' ? url : url.href;
        const malformedBase = base
            ? typeof base === 'string'
                ? base
                : base.href
            : undefined;
        logger.error({
            err,
            message: `Error constructing URL for url: ${malformedUrl} base: ${malformedBase}`,
            malformedUrl,
            malformedBase,
        }, 'Failed to construct URL');
        return null;
    }
};
